"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosStockTransferCreateInputSchema = exports.APosStockTransferSchema = exports.APosTransferItemSchema = exports.APosStockTransferStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosStockTransferStatusSchema = zod_1.z.enum([
    'draft', 'approved', 'in_transit', 'received', 'cancelled',
]);
exports.APosTransferItemSchema = zod_1.z.object({
    variantId: id_schema_1.EntityIdSchema,
    displayName: zod_1.z.string().optional(),
    requestedQuantity: zod_1.z.number().int().positive(),
    shippedQuantity: zod_1.z.number().int().nonnegative().optional(),
    receivedQuantity: zod_1.z.number().int().nonnegative().optional(),
    damagedQuantity: zod_1.z.number().int().nonnegative().optional(),
    damageNotes: zod_1.z.string().max(500).optional(),
});
exports.APosStockTransferSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    transferId: id_schema_1.EntityIdSchema,
    sourceLocationId: id_schema_1.EntityIdSchema,
    destinationLocationId: id_schema_1.EntityIdSchema,
    items: zod_1.z.array(exports.APosTransferItemSchema).min(1),
    status: exports.APosStockTransferStatusSchema.default('draft'),
    notes: zod_1.z.string().max(2000).optional(),
    createdBy: id_schema_1.EntityIdSchema,
    approvedBy: id_schema_1.EntityIdSchema.optional(),
    approvedAt: zod_1.z.number().optional(),
    shippedAt: zod_1.z.number().optional(),
    shippedBy: id_schema_1.EntityIdSchema.optional(),
    receivedAt: zod_1.z.number().optional(),
    receivedBy: id_schema_1.EntityIdSchema.optional(),
    cancelledAt: zod_1.z.number().optional(),
    cancelledBy: id_schema_1.EntityIdSchema.optional(),
    cancelReason: zod_1.z.string().max(500).optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosStockTransferCreateInputSchema = zod_1.z.object({
    sourceLocationId: id_schema_1.EntityIdSchema,
    destinationLocationId: id_schema_1.EntityIdSchema,
    items: zod_1.z.array(zod_1.z.object({
        variantId: id_schema_1.EntityIdSchema,
        displayName: zod_1.z.string().optional(),
        requestedQuantity: zod_1.z.number().int().positive(),
    })).min(1),
    notes: zod_1.z.string().max(2000).optional(),
});
//# sourceMappingURL=stock-transfer.schema.js.map